import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";

import Link from "@khanacademy/wonder-blocks-link";
import {font, sizing} from "@khanacademy/wonder-blocks-tokens";
import {LabelMedium} from "@khanacademy/wonder-blocks-typography";
import {getLoginUrl, preserveSearchParams, useLocation} from "@khan/urls";

/**
 * Props for the AlreadyHaveAccount component.
 */
interface Props {
    /**
     * The copy to display before the "Log in" link.
     */
    copy?: string;
    /**
     * The path to the login page.
     */
    loginPath?: string;
}

/**
 * A component that displays a message for users who already have a KA account.
 * Allowing them to log in, instead of sign up.
 *
 * NOTE: search params are preserved when changing to Log In.
 */
export function AlreadyHaveAccount({copy, loginPath}: Props): React.ReactNode {
    const location = useLocation();

    return (
        <LabelMedium style={styles.label}>
            {copy || t`Already have a Khan Academy account?`}{" "}
            <Link
                href={preserveSearchParams(
                    loginPath || getLoginUrl(),
                    new URLSearchParams(location.search),
                )}
                style={styles.link}
            >
                {t`Log in`}
            </Link>
        </LabelMedium>
    );
}

const styles = StyleSheet.create({
    link: {
        fontWeight: font.weight.bold,
        textDecoration: "underline",
    },
    label: {
        margin: `${sizing.size_160}px 0`,
    },
});
